/* ============================================================================
   pdp-reviews.js — hydratisiert den theme-eigenen Bewertungs-Container
   (snippets/pdp-reviews.liquid) mit Judge.me-Daten in UNSER Markup.

   Architektur (docs/17-judgeme-reviews.md):
     • Die Summary (Schnitt + Anzahl) rendert bereits server-seitig aus den
       reviews.* Metafeldern — dieses Script ergänzt NUR Histogramm, Liste,
       Foto-Strip, Händler-Antworten und KI-Zusammenfassung.
     • Datenquelle über EINEN isolierten Adapter `loadModel()`:
         1. Fixtures  (data-rv-fixtures, Demo-/QA-Modus) — voll funktionsfähig.
         2. Judge.me Cache-Server (Production, Awesome) — JSON ODER Widget-HTML;
            `normalize()` toleriert beide Formen. ⚠ Erst nach Awesome + Public-Token
            gegen echte Antwort verifizieren (eine Funktion, klar isoliert).
     • Fällt etwas aus → Skeletons weg, Summary bleibt, dezenter Status. Nie kaputt.
   ========================================================================== */
(function () {
  'use strict';

  var AVATAR_PALETTE = [
    { bg: 'var(--door-tint)', fg: 'var(--door-cta)' },
    { bg: 'var(--climate-tint)', fg: 'var(--climate-cta)' },
    { bg: 'var(--garden-tint)', fg: 'var(--garden-cta)' },
    { bg: 'var(--multimedia-tint)', fg: 'var(--multimedia-cta)' },
    { bg: 'var(--health-tint)', fg: 'var(--health-cta)' }
  ];
  var PHOTO_ICON = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="4" width="18" height="16" rx="2"/><circle cx="8.5" cy="9.5" r="1.5"/><path d="m21 16-5-5L5 20"/></svg>';
  var HOUSE_ICON = '<svg class="hm-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 11l9-8 9 8M5 10v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V10"/></svg>';
  var CHECK_ICON = '<svg class="hm-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 6 9 17l-5-5"/></svg>';
  // Quellen-Label-Fallback, wenn ein Set/Produkt kein Bild hat (kleine „Paket"-Silhouette)
  var BOX_ICON = '<svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M21 8 12 3 3 8v8l9 5 9-5z"/><path d="M3 8l9 5 9-5M12 13v8"/></svg>';

  // I18N lebt pro Container in cfg.i18n (init() liest [data-rv-i18n]) — kein Modul-Global,
  // damit mehrere [data-reviews]-Container auf einer Seite sich die Texte nicht überschreiben.
  function L(i18n, key, fallback) { return (i18n && i18n[key] != null && i18n[key] !== '') ? i18n[key] : fallback; }
  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }
  /* ---------------- Sterne (inkl. HALBER Sterne) ----------------
     Gezeichnet wird NICHT hier: pdp-reviews.liquid legt drei <template data-rv-star="…">
     mit exakt den SVGs ab, die auch snippets/star-row.liquid serverseitig rendert. Das JS
     klont daraus. So gibt es im ganzen Theme nur EINE Sternquelle — Pfadgeometrie und
     Halb-Darstellung koennen zwischen Server und Client nicht auseinanderlaufen.
     Rundung identisch zu star-row.liquid: auf den naechsten halben Stern (4,7 → 4,5). */
  var STAR_TPL = {};
  function starNode(kind) {
    if (!(kind in STAR_TPL)) {
      var t = document.querySelector('[data-rv-star="' + kind + '"]');
      STAR_TPL[kind] = (t && t.content && t.content.firstElementChild) || null;
    }
    return STAR_TPL[kind] ? STAR_TPL[kind].cloneNode(true) : null;
  }
  function starHalves(rating) {
    var h = Math.round((Number(rating) || 0) * 2);
    return Math.max(0, Math.min(10, h));
  }
  /* Fuellt `target` mit 5 Sternen. Fallback auf Textzeichen, falls die Templates fehlen
     (z. B. alt gecachtes HTML) — lieber ganze Sterne als gar keine. */
  function fillStars(target, rating) {
    var halves = starHalves(rating);
    target.textContent = '';
    var glyphs = '';
    for (var i = 1; i <= 5; i++) {
      var kind = halves >= i * 2 ? 'full' : (halves === i * 2 - 1 ? 'half' : 'empty');
      var node = starNode(kind);
      if (node) target.appendChild(node);
      else glyphs += kind === 'empty' ? '☆' : '★';
    }
    if (glyphs) target.textContent = glyphs;
    return target;
  }
  /* „4,7 von 5 Sternen" — nennt den EXAKTEN Wert, genau wie das aria-label in
     snippets/rating.liquid. Screenreader hoeren dadurch ueberall dieselbe Zahl; die
     Halb-Rundung ist reine Optik und darf nicht in die Vorlesung durchschlagen. */
  function starsLabel(rating) {
    var n = Math.round((Number(rating) || 0) * 10) / 10;
    return String(n).replace('.', ',');
  }
  function initials(name) {
    var parts = String(name || '').trim().split(/\s+/).filter(Boolean);
    if (!parts.length) return '–';
    var a = parts[0][0] || '';
    var b = parts.length > 1 ? (parts[parts.length - 1][0] || '') : '';
    return (a + b).toUpperCase();
  }

  /* ---------------- Datenschutz: nur der Vorname wird angezeigt ----------------
     Judge.me kennt für „Format des Bewertungsnamens" nur drei Stufen: voller Name,
     Nachname abgekürzt („Katharina M.") und alles als Initialen („K. M."). Ein
     „nur Vorname" gibt es dort nicht. Im Shop ist die mittlere Stufe gesetzt — die
     wirkt bereits SERVER-seitig auf reviews_for_widget, der Nachname verlässt Judge.me
     also gar nicht mehr. Hier fällt zusätzlich die Initiale weg, sodass am Ende nur
     noch der Vorname im DOM landet. Nicht entfernen, ohne die Judge.me-Einstellung
     mitzudenken: fällt sie je auf „voller Name" zurück, ist das hier die Absicherung.

     Titel werden übersprungen, damit aus „Dr. Klaus M." nicht „Dr." wird. Ein bereits
     anonymisierter Name („Anonym") bleibt unverändert, weil er nur aus einem Token besteht. */
  var NAME_TITLES = /^(dr|prof|dipl|ing|mag|herr|frau|mr|mrs|ms|miss)\.?$/i;
  function firstNameOnly(raw) {
    var s = String(raw == null ? '' : raw).replace(/\s+/g, ' ').trim();
    if (!s) return '';
    var parts = s.split(' ');
    var i = 0;
    while (i < parts.length - 1 && NAME_TITLES.test(parts[i])) i++;
    var first = parts[i] || '';
    // Satzzeichen am Ende kappen („Katharina," → „Katharina"). Ein reiner Initial („J.") behält
    // seinen Punkt — sonst bliebe ein nacktes „J" stehen.
    var trimmed = first.replace(/[),.;:]+$/, '');
    return trimmed.length >= 2 ? trimmed : first;
  }
  /* ---------------- „Leer" heißt wirklich leer ----------------
     Judge.mes CSV-Import verlangt ein Body-Feld — reine Sterne-Bewertungen wurden darum mit einem
     unsichtbaren Platzhalter importiert (`<p>&#8203;</p>` = Zero-Width-Space U+200B). `String.trim()`
     räumt U+200B NICHT weg (er zählt in JS nicht als Whitespace), also galt so eine Bewertung als
     inhaltsvoll: hasCardContent() sagte „ja", und die Karte erschien mit leerem Textabsatz.
     cleanText() entfernt unsichtbare Format-/Steuerzeichen (Soft Hyphen, Zero-Width, Bidi-Marker,
     BOM) und trimmt danach — damit landen solche Bewertungen wieder korrekt bei „nur Sterne".
     Zeilentrenner (U+2028/2029) bleiben absichtlich drin: sie sind echte Umbrüche, kein Nichts. */
  var INVISIBLE_RE = /[\u00AD\u200B-\u200F\u202A-\u202E\u2060-\u2064\uFEFF]/g;
  function cleanText(v) {
    return v == null ? '' : String(v).replace(INVISIBLE_RE, '').trim();
  }

  /* erlaubt nur <b>/<strong> in der KI-Zusammenfassung, escapt den Rest (XSS-sicher) */
  function safeEmphasis(str) {
    var esc = String(str == null ? '' : str)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    return esc.replace(/&lt;(\/?)(b|strong)&gt;/gi, '<$1$2>');
  }

  /* ---------------- Adapter: liefert ein normalisiertes Modell ---------------- */
  function readFixtures(root) {
    var s = root.querySelector('[data-rv-fixtures]');
    if (!s) return null;
    try {
      var m = normalizeModel(JSON.parse(s.textContent));
      // Demo-Modell: Schnitt/Anzahl NICHT aus den 6 Fixture-Karten ableiten — im QA sollen die
      // server-seitig gesetzten Demo-Werte (4,8 / 212) stehen bleiben.
      m.demo = true;
      return m;
    } catch (e) { return null; }
  }

  // Ein Produkt laden — über denselben Endpoint, den Judge.mes EIGENES Widget-JS nutzt:
  //   GET judge.me/reviews/reviews_for_widget
  //       ?url=<shop>&shop_domain=<shop>&platform=shopify&product_id=<Shopify-Produkt-ID>
  //       &page=1&per_page=30
  // Liefert SAUBERES JSON ({reviews:[…], histogram:[…], pagination:{…}, number_of_reviews}) statt
  // Widget-HTML, ist CORS-offen (Access-Control-Allow-Origin: *) und braucht KEINEN Token.
  // per_page wird serverseitig auf 30 gedeckelt.
  //
  // ⚠ NICHT zurück auf /api/v1/widgets/product_review wechseln: Dieser Endpoint liefert für denselben
  // Store und dieselbe Produkt-ID seit ~2026-07 nur noch "<div></div>", OBWOHL die Reviews existieren
  // (preview_badge + reviews_for_widget geben sie zurück, Judge.me-Admin zeigt sie als veröffentlicht).
  // Er war die Ursache dafür, dass die Liste dauerhaft im „wird geladen"-Zustand hing. Verifiziert
  // 2026-07-16. Ebenfalls unbrauchbar: cache.judge.me/widgets/… („Shop not found").
  //
  // Produkt NUR via product_id (Shopify-ID) — `handle` unterstützt dieser Endpoint NICHT.
  function fetchOne(cfg, ident) {
    var id = (ident && ident.id) || '';
    if (!cfg.shopDomain || !id) return Promise.resolve(null);
    var url = 'https://judge.me/reviews/reviews_for_widget' +
      '?url=' + encodeURIComponent(cfg.shopDomain) +
      '&shop_domain=' + encodeURIComponent(cfg.shopDomain) +
      '&platform=shopify&page=1&per_page=30' +
      '&product_id=' + encodeURIComponent(id);
    return fetch(url, { headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('jdgm ' + r.status); return r.text(); })
      .then(function (text) {
        var data;
        try { data = JSON.parse(text); } catch (e) { data = text; }
        return normalize(data, cfg);
      });
  }

  // Bundle-PDP: mehrere Quellen (Set + enthaltene Produkte) parallel laden, jede Review mit ihrer Quelle
  // taggen (Label an der Karte), zusammenführen und nach Datum absteigend sortieren. Fällt eine Quelle aus,
  // wird sie übersprungen (leere Liste) — die übrigen Reviews erscheinen trotzdem.
  function loadMulti(cfg) {
    var jobs = cfg.sources.map(function (src) {
      return fetchOne(cfg, { handle: src.handle, id: src.id })
        .then(function (model) {
          var revs = (model && model.reviews) ? model.reviews : [];
          revs.forEach(function (r) { r.source = src.title; r.sourceImage = src.image || ''; });
          return { reviews: revs, total: model && model.total, average: model && model.average };
        })
        .catch(function () { return { reviews: [] }; });
    });
    return Promise.all(jobs).then(function (parts) {
      var all = [], total = 0, weighted = 0;
      parts.forEach(function (p) {
        all = all.concat(p.reviews);
        // Gewichteter Gesamtschnitt über alle Quellen (Set + enthaltene Produkte) — identische
        // Rechnung wie server-seitig in main-product.liquid, nur mit den LIVE-Zahlen von Judge.me.
        var t = (p.total != null) ? p.total : p.reviews.length;
        if (t > 0) {
          total += t;
          if (p.average != null) weighted += p.average * t;
        }
      });
      all.sort(function (a, b) { return (b.ts || 0) - (a.ts || 0); });
      return normalizeModel({
        reviews: all,
        histogram: histogramFromReviews(all),
        total: total,
        average: total > 0 && weighted > 0 ? weighted / total : null
      });
    });
  }

  function loadModel(root, cfg) {
    var fx = readFixtures(root);
    if (fx) return Promise.resolve(fx);
    if (cfg.sources && cfg.sources.length) return loadMulti(cfg);
    return fetchOne(cfg, { handle: cfg.productHandle, id: cfg.productId });
  }

  /* Toleriert (a) rohen HTML-String, (b) strukturierte Review-Objekte oder (c) verschachteltes jdgm-Widget-HTML. */
  function normalize(data, cfg) {
    if (!data) return null;
    // (roh) String = direkt geliefertes Widget-HTML/JS → jdgm-Markup extrahieren
    if (typeof data === 'string') {
      return data.indexOf('jdgm-rev') > -1 ? parseWidgetHtml(data, cfg.i18n) : null;
    }
    // (a) irgendwo ein Array review-artiger Objekte?
    // WICHTIG: auch ein LEERES reviews-Array ist eine gültige Antwort („0 Bewertungen") und muss ein
    // Modell ergeben — sonst ist „keine Bewertungen" nicht von „Abruf fehlgeschlagen" unterscheidbar
    // und der Empty-State bliebe aus (das war die Ursache des irreführenden „wird geladen"-Zustands).
    var arr = findReviewArray(data);
    if (arr) {
      var mapped = arr.map(function (r) { return mapApiReview(r, cfg.i18n); });
      return normalizeModel({
        reviews: mapped,
        // Echtes Histogramm der API bevorzugen; normalizeModel fällt sonst auf die geladenen Reviews zurück.
        histogram: mapApiHistogram(data.histogram),
        // Gesamtzahl/Schnitt über ALLE Bewertungen (nicht nur die geladene Seite) — überschreibt die
        // ggf. veraltete Metafeld-Summary, damit frisch freigeschaltete Bewertungen sofort zählen.
        total: toInt(data.number_of_reviews),
        average: toNum(data.average_rating)
      });
    }
    // (b) Widget-HTML extrahieren
    var html = findWidgetHtml(data, cfg);
    if (html) return parseWidgetHtml(html, cfg.i18n);
    return null;
  }
  function toInt(v) { var n = parseInt(v, 10); return isNaN(n) ? null : n; }
  function toNum(v) { var n = parseFloat(v); return isNaN(n) ? null : n; }

  function findReviewArray(data) {
    if (Array.isArray(data.reviews)) return data.reviews;
    var keys = Object.keys(data || {}), i, v;
    for (i = 0; i < keys.length; i++) {
      v = data[keys[i]];
      if (Array.isArray(v) && v.length && v[0] && typeof v[0] === 'object' && ('rating' in v[0] || 'body' in v[0])) return v;
      if (v && typeof v === 'object' && Array.isArray(v.reviews)) return v.reviews;
    }
    return null;
  }
  function findWidgetHtml(data, cfg) {
    var stack = [data], seen = 0;
    while (stack.length && seen < 400) {
      var cur = stack.pop(); seen++;
      if (typeof cur === 'string') { if (cur.indexOf('jdgm-rev') > -1) return cur; continue; }
      if (cur && typeof cur === 'object') for (var k in cur) if (Object.prototype.hasOwnProperty.call(cur, k)) stack.push(cur[k]);
    }
    return null;
  }
  /* Judge.me liefert Text als HTML (body_html/reply_content, z. B. „<p>…</p>"). Unser Markup rendert
     reinen Text (textContent), darum sicher zu Text wandeln: Block-Umbrüche erhalten, Rest entkernen.
     DOMParser führt weder Skripte aus noch lädt es Ressourcen (kein innerHTML!) → XSS-sicher. */
  function htmlToText(html) {
    if (html == null) return '';
    var s = String(html);
    if (s.indexOf('<') === -1) return cleanText(s);
    s = s.replace(/<\/p\s*>/gi, '\n\n').replace(/<br\s*\/?>/gi, '\n');
    try {
      var doc = new DOMParser().parseFromString(s, 'text/html');
      return cleanText((doc.body.textContent || '').replace(/\n{3,}/g, '\n\n'));
    } catch (e) {
      return cleanText(s.replace(/<[^>]*>/g, ''));
    }
  }
  /* Fotos: reviews_for_widget liefert `pictures_urls` (Strings ODER {compact,…}); ältere/andere
     Formen (pictures/photos mit .urls) bleiben tolerant unterstützt. */
  function mapPhotos(r) {
    var raw = r.pictures_urls || r.pictures || r.photos || [];
    if (!Array.isArray(raw)) return [];
    return raw.map(function (p) {
      if (typeof p === 'string') return { url: p };
      if (p && p.urls) return { url: p.urls.compact || p.urls.small || p.urls.original || '' };
      return { url: (p && (p.compact || p.small || p.original || p.url)) || '' };
    }).filter(function (p) { return p.url; });
  }
  function mapApiReview(r, i18n) {
    return {
      name: r.reviewer && r.reviewer.name ? r.reviewer.name : (r.reviewer_name || r.name || L(i18n, 'anonymous', 'Anonym')),
      rating: Number(r.rating) || 0,
      // reviews_for_widget: `verified_buyer` (bool). Ältere Form `verified: 'buyer'` bleibt unterstützt.
      verified: r.verified_buyer === true || r.verified === 'buyer' || r.verified === true,
      date: r.created_at ? relTime(r.created_at, i18n) : (r.date || ''),
      ts: toTs(r.created_at),
      title: cleanText(r.title),
      body: htmlToText(r.body_html || r.body),
      photos: mapPhotos(r),
      reply: mapReply(r)
    };
  }
  function mapReply(r) {
    var raw = r.reply_content;
    if (raw == null && r.reply) raw = typeof r.reply === 'string' ? r.reply : (r.reply.body || r.reply.text || '');
    var t = htmlToText(raw);
    return t ? { text: t } : null;
  }
  /* Judge.me-Histogramm ([{rating,frequency,percentage}]) → unser {star,pct}. Besser als
     histogramFromReviews(): deckt ALLE Bewertungen ab, nicht nur die geladene Seite. */
  function mapApiHistogram(h) {
    if (!Array.isArray(h)) return null;
    var out = [];
    h.forEach(function (x) {
      var star = Number(x && x.rating);
      if (star >= 1 && star <= 5) out.push({ star: star, pct: Number(x.percentage) || 0 });
    });
    return out.length ? out : null;
  }
  function parseWidgetHtml(html, i18n) {
    var doc;
    try { doc = new DOMParser().parseFromString(html, 'text/html'); } catch (e) { return null; }
    // Feld-Mapping gegen das ECHTE jdgm-Widget-Markup (verifiziert 2026-07 am Live-Response):
    //   Rating   → .jdgm-rev__rating[data-score]   (Fallback: Anzahl .jdgm-star.jdgm--on)
    //   Datum    → .jdgm-rev__timestamp[data-content] (Text ist leer, füllt sonst Judge.me-JS)
    //   Verifiz. → .jdgm-rev[data-verified-buyer='true']
    //   Antwort  → .jdgm-rev__reply-content
    var reviews = [].map.call(doc.querySelectorAll('.jdgm-rev'), function (n) {
      var ratingEl = n.querySelector('.jdgm-rev__rating');
      var rating = ratingEl && ratingEl.getAttribute('data-score')
        ? Number(ratingEl.getAttribute('data-score'))
        : (n.querySelectorAll('.jdgm-star.jdgm--on').length || 0);
      var tsEl = n.querySelector('.jdgm-rev__timestamp');
      var tsRaw = tsEl ? (tsEl.getAttribute('data-content') || tsEl.textContent || '') : '';
      var replyEl = n.querySelector('.jdgm-rev__reply');
      var replyText = replyEl ? (txt(replyEl, '.jdgm-rev__reply-content') || '').trim() : '';
      return {
        name: txt(n, '.jdgm-rev__author') || L(i18n, 'anonymous', 'Anonym'),
        rating: rating,
        verified: n.getAttribute('data-verified-buyer') === 'true' || !!n.querySelector('.jdgm-rev__buyer-badge'),
        date: relTime(tsRaw, i18n) || tsRaw,
        ts: toTs(tsRaw),
        title: txt(n, '.jdgm-rev__title'),
        body: txt(n, '.jdgm-rev__body'),
        photos: [].map.call(n.querySelectorAll('.jdgm-rev__pic img, .jdgm-rev__pics img'), function (im) { return { url: im.getAttribute('data-src') || im.src }; }),
        reply: replyText ? { text: replyText } : null
      };
    });
    var hist = [].map.call(doc.querySelectorAll('.jdgm-histogram__row'), function (row) {
      return { star: Number(row.getAttribute('data-rating')), pct: Number(row.getAttribute('data-percentage')) || 0 };
    }).filter(function (h) { return h.star >= 1 && h.star <= 5; });
    return normalizeModel({ reviews: reviews, histogram: hist.length ? hist : histogramFromReviews(reviews) });
  }
  function txt(scope, sel) { var n = scope.querySelector(sel); return n ? cleanText(n.textContent) : ''; }

  function histogramFromReviews(reviews) {
    var buckets = { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0 }, total = 0;
    reviews.forEach(function (r) { var k = Math.round(r.rating); if (buckets[k] != null) { buckets[k]++; total++; } });
    return [5, 4, 3, 2, 1].map(function (s) { return { star: s, pct: total ? Math.round((buckets[s] / total) * 100) : 0 }; });
  }
  // Epoch-ms aus einem Judge.me-/ISO-Datum (für die Sortierung der gemischten Bundle-Liste). 0 = unbekannt.
  function toTs(iso) {
    if (!iso) return 0;
    var d = new Date(String(iso).replace(' UTC', 'Z').replace(' ', 'T'));
    return isNaN(d) ? 0 : d.getTime();
  }
  function relTime(iso, i18n) {
    if (!iso) return '';
    // Judge.me liefert z. B. „2026-06-11 22:00:00 UTC" → in parsebares ISO wandeln.
    var d = new Date(String(iso).replace(' UTC', 'Z').replace(' ', 'T'));
    if (isNaN(d)) return '';
    var days = Math.floor((Date.now() - d.getTime()) / 86400000);
    if (days <= 0) return L(i18n, 'dateToday', 'Heute');
    if (days === 1) return L(i18n, 'dateYesterday', 'Gestern');
    if (days < 14) return L(i18n, 'dateDays', 'Vor %n% Tagen').replace('%n%', days);
    if (days < 60) return L(i18n, 'dateWeeks', 'Vor %n% Wochen').replace('%n%', Math.floor(days / 7));
    return L(i18n, 'dateMonths', 'Vor %n% Monaten').replace('%n%', Math.floor(days / 30));
  }
  function normalizeModel(m) {
    m = m || {};
    m.reviews = Array.isArray(m.reviews) ? m.reviews : [];
    // JEDE Quelle (JSON-API, Widget-HTML, Fixtures) läuft hier durch → eine einzige Stelle, an der
    // Textfelder normalisiert werden. Danach gilt verlässlich: leerer String = kein Inhalt.
    m.reviews.forEach(sanitizeReview);
    if (!Array.isArray(m.histogram) || !m.histogram.length) m.histogram = histogramFromReviews(m.reviews);
    // total/average sind optional (nur der JSON-Pfad liefert sie) → sonst aus der Liste ableiten.
    if (m.total == null) m.total = m.reviews.length;
    if (m.average == null) m.average = averageFromReviews(m.reviews);
    return m;
  }
  function averageFromReviews(reviews) {
    var sum = 0, n = 0;
    reviews.forEach(function (r) { if (r.rating > 0) { sum += r.rating; n++; } });
    return n ? sum / n : null;
  }
  function sanitizeReview(r) {
    if (!r) return;
    r.title = cleanText(r.title);
    r.body = cleanText(r.body);
    if (r.reply) {
      var t = cleanText(r.reply.text);
      if (t) r.reply.text = t; else r.reply = null;
    }
  }

  /* Sterne-only-Bewertungen (kein Titel, kein Text, keine Fotos, keine Händler-Antwort) bekommen
     keine eigene Karte — sie wären nur „Anonym + Sterne". Das gilt auch für Bewertungen, deren
     Text nur aus unsichtbaren Zeichen besteht (Import-Platzhalter, s. cleanText). Sie zählen aber
     weiterhin voll in Schnitt, Anzahl und Histogramm: applySummary/renderHistogram arbeiten auf
     model.total/model.histogram (Live-Zahlen von Judge.me) und bleiben ungefiltert. */
  function hasCardContent(r) {
    if (cleanText(r.title)) return true;
    if (cleanText(r.body)) return true;
    if ((r.photos || []).filter(Boolean).length) return true;
    if (r.reply && cleanText(r.reply.text)) return true;
    return false;
  }

  /* ---------------------------- Rendering ---------------------------- */
  function buildCard(r, idx, i18n) {
    var card = el('li', 'hm-reviews__card');

    // Quellen-Label (nur Bundle): auf welches Set/Produkt sich die Review bezieht. r.source wird nur
    // im Bundle-Modus gesetzt (loadMulti-Tagging oder Bundle-Fixtures) → auf der Einzel-PDP kein Label.
    if (r.source) {
      var srcTag = el('div', 'hm-reviews__src');
      srcTag.title = r.source;
      srcTag.appendChild(el('span', 'visually-hidden', L(i18n, 'sourcePrefix', 'Bewertung zu') + ' '));
      if (r.sourceImage) {
        var sim = new Image(); sim.className = 'hm-reviews__src-thumb'; sim.loading = 'lazy'; sim.src = r.sourceImage; sim.alt = '';
        srcTag.appendChild(sim);
      } else {
        var sic = el('span', 'hm-reviews__src-ic'); sic.innerHTML = BOX_ICON; sic.setAttribute('aria-hidden', 'true');
        srcTag.appendChild(sic);
      }
      srcTag.appendChild(el('span', 'hm-reviews__src-txt', r.source));
      card.appendChild(srcTag);
    }

    var top = el('div', 'hm-reviews__card-top');

    // EINZIGE Stelle, an der ein Reviewer-Name ins DOM geht — Kürzung deshalb hier, damit sie
    // für jede Quelle gilt (JSON-API, Widget-HTML-Fallback, Demo-Fixtures). Das Avatar-Kürzel
    // leitet sich vom gekürzten Namen ab und kann so keine Nachnamen-Initiale durchreichen.
    var displayName = firstNameOnly(r.name) || L(i18n, 'anonymous', 'Anonym');

    var author = el('div', 'hm-reviews__author');
    var pal = AVATAR_PALETTE[idx % AVATAR_PALETTE.length];
    var av = el('span', 'hm-reviews__avatar', initials(displayName));
    av.style.setProperty('--av-bg', pal.bg); av.style.setProperty('--av-fg', pal.fg);
    av.setAttribute('aria-hidden', 'true');
    var who = el('div', 'hm-reviews__who');
    who.appendChild(el('span', 'hm-reviews__name', displayName));
    if (r.verified) {
      var vb = el('span', 'hm-reviews__verified');
      vb.innerHTML = CHECK_ICON;
      vb.appendChild(document.createTextNode(' ' + L(i18n, 'verified', 'Verifizierter Kauf')));
      who.appendChild(vb);
    }
    author.appendChild(av); author.appendChild(who);

    var cs = fillStars(el('span', 'hm-stars hm-reviews__card-stars'), r.rating);
    cs.setAttribute('aria-label', L(i18n, 'starsOf5', '%n% von 5 Sternen').replace('%n%', starsLabel(r.rating)));
    top.appendChild(author); top.appendChild(cs);
    card.appendChild(top);

    if (r.title) card.appendChild(el('h3', 'hm-reviews__card-title', r.title));
    if (r.body) card.appendChild(el('p', 'hm-reviews__card-body', r.body));

    var pics = (r.photos || []).filter(Boolean);
    if (pics.length) {
      var pr = el('div', 'hm-reviews__card-photos');
      pics.slice(0, 4).forEach(function (ph) { pr.appendChild(buildThumb(ph, i18n)); });
      card.appendChild(pr);
    }

    if (r.reply && r.reply.text) {
      var rep = el('div', 'hm-reviews__reply');
      var rh = el('div', 'hm-reviews__reply-head');
      rh.innerHTML = HOUSE_ICON;
      rh.appendChild(document.createTextNode(' ' + L(i18n, 'replyFrom', 'Antwort von Homedia')));
      rep.appendChild(rh);
      rep.appendChild(el('p', 'hm-reviews__reply-text', r.reply.text));
      card.appendChild(rep);
    }

    var foot = el('p', 'hm-reviews__card-foot');
    if (r.date) foot.appendChild(el('span', 'hm-reviews__foot-date', r.date + ' · '));
    foot.appendChild(el('span', 'hm-reviews__foot-q', L(i18n, 'helpfulQ', 'War das hilfreich?') + ' '));
    var help = el('button', 'hm-reviews__helpful');
    help.type = 'button';
    var yes = L(i18n, 'helpfulYes', 'Ja');
    var votes = 0;
    help.textContent = yes;
    help.setAttribute('aria-pressed', 'false');
    help.addEventListener('click', function () {
      var on = help.getAttribute('aria-pressed') === 'true';
      votes += on ? -1 : 1;
      help.setAttribute('aria-pressed', on ? 'false' : 'true');
      help.textContent = yes + (votes > 0 ? ' (' + votes + ')' : '');
    });
    foot.appendChild(help);
    card.appendChild(foot);
    return card;
  }
  function buildThumb(ph, i18n) {
    var b = el('button', 'hm-reviews__pthumb'); b.type = 'button';
    b.setAttribute('aria-label', L(i18n, 'photoView', 'Bewertungsfoto ansehen'));
    if (ph && ph.url) {
      var im = new Image(); im.loading = 'lazy'; im.src = ph.url; im.alt = '';
      b.appendChild(im);
    } else {
      b.innerHTML = PHOTO_ICON;
    }
    return b;
  }

  function renderHistogram(root, hist) {
    (hist || []).forEach(function (h) {
      var row = root.querySelector('[data-rv-hist-row="' + h.star + '"]');
      if (!row) return;
      var fill = row.querySelector('.hm-reviews__hist-fill');
      var pct = row.querySelector('[data-rv-hist-pct]');
      var v = Math.max(0, Math.min(100, Math.round(h.pct)));
      if (fill) fill.style.width = v + '%';
      if (pct) pct.textContent = v + '%';
    });
  }
  function renderPhotos(root, model, i18n) {
    var wrap = root.querySelector('[data-rv-photos]');
    var strip = root.querySelector('[data-rv-photos-strip]');
    if (!wrap || !strip) return;
    var all = [];
    model.reviews.forEach(function (r) { (r.photos || []).forEach(function (p) { all.push(p); }); });
    if (!all.length) return;
    var total = model.photos_total || all.length;
    var label = root.querySelector('[data-rv-photos-label]');
    if (label) label.textContent = L(i18n, 'photosLabel', 'Fotos aus Bewertungen (%n%)').replace('%n%', total);
    all.slice(0, 12).forEach(function (p) { strip.appendChild(buildThumb(p, i18n)); });
    wrap.hidden = false;
  }
  function renderAi(root, ai) {
    if (!ai || !ai.text) return;
    var box = root.querySelector('[data-rv-ai]');
    if (!box) return;
    var txtEl = box.querySelector('[data-rv-ai-text]');
    if (txtEl) txtEl.innerHTML = safeEmphasis(ai.text);
    var chips = box.querySelector('[data-rv-ai-chips]');
    if (chips) {
      (ai.positives || []).forEach(function (c) { chips.appendChild(chip('pos', '+ ', c)); });
      (ai.negatives || []).forEach(function (c) { chips.appendChild(chip('neg', '− ', c)); });
    }
    var foot = box.querySelector('[data-rv-ai-foot]');
    if (foot && ai.footnote) { foot.textContent = ai.footnote; foot.hidden = false; }
    box.hidden = false;
  }
  function chip(kind, prefix, c) {
    var label = Array.isArray(c) ? c[0] + (c[1] != null ? ' (' + c[1] + ')' : '') : String(c);
    return el('span', 'hm-reviews__ai-chip hm-reviews__ai-chip--' + kind, prefix + label);
  }

  /* ------------------------- List + Filter + Paginierung ------------------------- */
  function setupList(root, model, cfg) {
    var listEl = root.querySelector('[data-rv-list]');
    var moreBtn = root.querySelector('[data-rv-more]');
    var status = root.querySelector('[data-rv-status]');
    // Mobile (≤749px): standardmäßig nur eine Bewertung sichtbar (spart Platz), der Rest
    // hängt hinter dem „Mehr"-Button. Desktop startet weiterhin mit der vollen Seitengröße.
    var isMobileView = !!(window.matchMedia && window.matchMedia('(max-width: 749px)').matches);
    var initialShown = isMobileView ? cfg.mobileInitial : cfg.pageSize;
    var state = { filter: 'all', shown: initialShown };

    // Nur Bewertungen mit sichtbarem Inhalt als Karte listen (s. hasCardContent).
    var listable = model.reviews.filter(hasCardContent);

    // Alles sterne-only → keine Karten, keine Filter, kein „Mehr"-Button. Summary + Histogramm
    // (inkl. dieser Bewertungen) bleiben stehen — statt einer leeren Liste mit Filter-Pillen.
    // An die Stelle der Liste tritt der Hinweis [data-rv-nolist], sonst bliebe die rechte
    // Spalte neben der Summary-Card komplett leer.
    if (!listable.length) {
      var filtersEl = root.querySelector('[data-rv-filters]');
      if (filtersEl) filtersEl.hidden = true;
      listEl.hidden = true;
      moreBtn.hidden = true;
      var noListEl = root.querySelector('[data-rv-nolist]');
      if (noListEl) noListEl.hidden = false;
      if (status) status.textContent = '';
      return;
    }

    function filtered() {
      if (state.filter === 'photos') return listable.filter(function (r) { return (r.photos || []).length; });
      if (state.filter === 'critical') return listable.filter(function (r) { return r.rating <= 3; });
      return listable;
    }
    function render(focusNew) {
      var data = filtered();
      var firstNewIdx = focusNew ? Math.min(state.shown - cfg.pageSize, data.length) : -1;
      listEl.innerHTML = '';
      var slice = data.slice(0, state.shown);
      slice.forEach(function (r, i) { listEl.appendChild(buildCard(r, i, cfg.i18n)); });
      if (!slice.length) {
        listEl.appendChild(el('li', 'hm-reviews__card', L(cfg.i18n, 'noneFilter', 'Keine Bewertungen für diesen Filter.')));
      }
      // „Mehr"-Button. Er blättert NUR die bereits geladene, gelistete Menge auf (er lädt nichts
      // nach) → mit der Zahl der wirklich vorhandenen Karten beschriften, nicht mit der
      // Gesamtzahl aus der Summary: die enthält auch Sterne-only-Bewertungen ohne Karte.
      var totalCount = data.length;
      if (state.shown < data.length) {
        moreBtn.hidden = false;
        moreBtn.textContent = L(cfg.i18n, 'showAll', 'Alle %n% Bewertungen anzeigen').replace('%n%', totalCount);
      } else {
        moreBtn.hidden = true;
      }
      if (status) status.textContent = '';
      if (focusNew && firstNewIdx >= 0 && listEl.children[firstNewIdx]) {
        var h = listEl.children[firstNewIdx].querySelector('.hm-reviews__card-title') || listEl.children[firstNewIdx];
        h.setAttribute('tabindex', '-1'); h.focus();
      }
    }

    moreBtn.addEventListener('click', function () {
      state.shown += cfg.pageSize;
      render(true);
    });

    var pills = root.querySelectorAll('[data-rv-filter]');
    [].forEach.call(pills, function (pill) {
      pill.addEventListener('click', function () {
        state.filter = pill.getAttribute('data-rv-filter');
        state.shown = initialShown;
        [].forEach.call(pills, function (p) {
          var active = p === pill;
          p.classList.toggle('is-active', active);
          p.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
        render(false);
      });
    });

    render(false);
  }

  /* ==================== „Bewertung schreiben" — Judge.me-Formular ====================
     WARUM DAS HIER SO AUSSIEHT (bitte vor dem Umbauen lesen):

     Judge.me hat 2026 auf das Review-Widget v3 („Revamp") umgestellt. Im Loader hängt das Laden von
     `widget/main.js` für einen `.jdgm-review-widget`-Mount seitdem an `review_widget_revamp_enabled
     == false` — bei uns ist das Flag AN. Folge: Judge.me rendert in unseren Mount nichts mehr, der
     `.jdgm-write-rev-link` aus ihrem Template entsteht nie, und der frühere „Link suchen und
     klicken"-Ansatz war live ein garantierter No-Op. Genau das war der tote Button.

     Zweite Falle: `widget/form.js` lädt der Loader nur, wenn die URL `#judgeme` oder einen
     `judgeme_*`-Parameter trägt — sonst wird es bloß PREFETCHED. Ohne dieses Bundle fehlt u. a.
     `jdgm._rtlStarsEnabled`; `_WriteReviewModal.setup()` wirft dann mitten im Aufbau
     (nach `_setupRatingStars`), das Modal bleibt halb verdrahtet — sichtbar, aber ohne
     Navigation und ohne Absenden — und das setup()-Promise löst nie auf. Verifiziert 2026-07-27.

     Lösung (ohne Judge.me-Interna nachzubauen):
       1. Beim Klick legen wir den Trigger-Link an, den Judge.mes Template sonst mitbringt:
          `.jdgm-write-rev-link` im versteckten Mount. BEWUSST erst hier und nicht server-seitig —
          Judge.mes `_customizeReviewWidget()` macht beim Setup ein `.detach()` auf diesen Link und
          hängt ihn in einen Actions-Wrapper, den es im Revamp-Modus nie anlegt; ein im HTML
          ausgelieferter Link wäre danach spurlos weg (verifiziert).
       2. Dann laden wir `widget_v3/form.css` + `widget/form.js` nach (beides dedupliziert Judge.me
          intern über `requestedUrls`).
       3. `form.js` bootstrappt beim Ausführen selbst: es baut das Modal auf und hängt seinen
          eigenen Click-Handler an unseren `.jdgm-write-rev-link`.
       4. Sobald `.jdgm-write-review-modal` im DOM liegt (= Bootstrap durch), klicken wir den Link.

     Ergebnis: genau EIN Modal, geöffnet über Judge.mes eigenen, vollständig verdrahteten Pfad —
     inkl. Sterne-Eingabe, Schritt-Navigation, Validierung, E-Mail-Verifizierung und Upload.
     =================================================================================== */
  var JDGM_MODAL_SELECTOR = '.jdgm-write-review-modal';

  /* Trigger-Link sicherstellen (siehe Punkt 1 oben). Kein href — Judge.me setzt beim Verdrahten
     selbst href="javascript:void(0)". tabindex="-1", damit der geclippte Mount keine
     Tastatur-Falle wird. */
  function ensureTriggerLink(root) {
    var existing = root.querySelector('.jdgm-write-rev-link') || document.querySelector('.jdgm-write-rev-link');
    if (existing) return existing;
    var mount = root.querySelector('.jdgm-review-widget');
    if (!mount) return null;
    var a = el('a', 'jdgm-write-rev-link');
    a.setAttribute('role', 'button');
    a.setAttribute('tabindex', '-1');
    mount.appendChild(a);
    return a;
  }

  /* Stößt die beiden fehlenden Judge.me-Bundles an. true = Anfrage abgesetzt (jdgm war da). */
  function requestWriteForm() {
    var j = window.jdgm;
    if (!j || typeof j.loadScript !== 'function' || typeof j.loadCSS !== 'function' ||
        typeof j.widgetPath !== 'function' || typeof j.CDN_HOST !== 'string') return false;
    try {
      j.loadCSS(j.widgetPath('form.css'));            // ohne sie rendert das Modal unformatiert
      j.loadScript(j.CDN_HOST + 'widget/form.js');    // beide dedupliziert Judge.me über requestedUrls
    } catch (e) { return false; }
    return true;
  }
  function waitUntil(test, timeoutMs, onTick) {
    if (test()) return Promise.resolve(true);
    return new Promise(function (resolve) {
      var waited = 0, step = 120;
      var iv = setInterval(function () {
        if (test()) { clearInterval(iv); resolve(true); return; }
        if (onTick) onTick();
        if ((waited += step) >= timeoutMs) { clearInterval(iv); resolve(false); }
      }, step);
    });
  }
  function openWriteForm(root) {
    var link = ensureTriggerLink(root);
    if (!link) return Promise.reject(new Error('kein Judge.me-Mount im DOM'));
    var requested = requestWriteForm();
    return waitUntil(
      function () { return !!document.querySelector(JDGM_MODAL_SELECTOR); },
      8000,
      function () { if (!requested) requested = requestWriteForm(); }   // App-Embed kam evtl. später
    ).then(function (ready) {
      if (!ready) throw new Error('Judge.me-Formular nicht rechtzeitig bereit');
      link.click();
      return true;
    });
  }

  function setupWrite(root, cfg) {
    var btns = root.querySelectorAll('[data-rv-write]');
    if (!btns.length) return;
    var status = root.querySelector('[data-rv-status]');

    function busy(on) {
      [].forEach.call(btns, function (b) {
        b.disabled = on;
        b.setAttribute('aria-busy', on ? 'true' : 'false');
      });
    }

    [].forEach.call(btns, function (btn) {
      btn.addEventListener('click', function () {
        // Hook für Analytics/eigene Erweiterungen — bleibt erhalten.
        root.dispatchEvent(new CustomEvent('hm:review-write', { bubbles: true, detail: { productId: cfg.productId } }));
        busy(true);
        if (status) status.textContent = '';
        openWriteForm(root).then(function () {
          busy(false);
        }).catch(function (err) {
          busy(false);
          if (status) status.textContent = L(cfg.i18n, 'writeError', 'Das Bewertungsformular konnte nicht geladen werden. Bitte lade die Seite neu.');
          if (window && window.console) console.warn('[pdp-reviews] write', err);
        });
      });
    });
  }

  /* ---- Summary aus LIVE-Daten nachziehen (Metafeld-Sync von Judge.me läuft verzögert) ----
     Server rendert Schnitt/Anzahl aus reviews.rating / reviews.rating_count. Diese Metafelder
     schreibt Judge.me nur periodisch — eine gerade freigeschaltete Bewertung wäre sonst erst
     Stunden später sichtbar (und auf einem Produkt mit bis dahin 0 Bewertungen bliebe die Sektion
     im Empty-State hängen). Deshalb: Zahlen aus der Live-Antwort überschreiben. */
  function applySummary(root, model) {
    var total = model.total || 0;
    var avg = model.average;

    [].forEach.call(root.querySelectorAll('[data-rv-count]'), function (n) { n.textContent = total; });

    var avgEl = root.querySelector('[data-rv-avg]');
    if (avgEl && avg != null) {
      var rounded = Math.round(avg * 10) / 10;
      avgEl.textContent = String(rounded.toFixed(1)).replace('.', ',');
      var starRow = root.querySelector('.hm-reviews__stars--lg');
      // Gleiche Logik wie snippets/star-row.liquid: auf den naechsten HALBEN Stern runden.
      if (starRow) fillStars(starRow, rounded);
    }
    root.setAttribute('data-count', total);
  }

  /* Grid vs. Empty-State umschalten — beides ist server-seitig da, nur die Sichtbarkeit wechselt. */
  function showEmpty(root, isEmpty) {
    var grid = root.querySelector('[data-rv-grid]');
    var empty = root.querySelector('[data-rv-empty]');
    if (grid) grid.hidden = isEmpty;
    if (empty) empty.hidden = !isEmpty;
  }

  /* ------------------------------ Init ------------------------------ */

  function clearSkeletons(root) {
    [].forEach.call(root.querySelectorAll('.hm-reviews__card--skeleton'), function (n) { n.remove(); });
  }

  function init(root) {
    if (root.__hmRvInit) return; root.__hmRvInit = true;
    var i18n = {};
    var i18nEl = root.querySelector('[data-rv-i18n]');
    if (i18nEl) { try { i18n = JSON.parse(i18nEl.textContent) || {}; } catch (e) { i18n = {}; } }
    // Bundle-Quellen (Set + enthaltene Produkte) — nur auf der Bundle-PDP vorhanden.
    var sources = [];
    var srcEl = root.querySelector('[data-rv-sources]');
    if (srcEl) { try { sources = JSON.parse(srcEl.textContent) || []; } catch (e) { sources = []; } }
    var cfg = {
      i18n: i18n,
      productId: root.getAttribute('data-product-id'),
      productHandle: root.getAttribute('data-product-handle'),
      shopDomain: root.getAttribute('data-shop-domain'),
      token: root.getAttribute('data-token'),
      pageSize: parseInt(root.getAttribute('data-page-size'), 10) || 5,
      mobileInitial: parseInt(root.getAttribute('data-page-size-mobile'), 10) || 1,
      sources: Array.isArray(sources) ? sources : []
    };
    setupWrite(root, cfg);
    var status = root.querySelector('[data-rv-status]');

    loadModel(root, cfg).then(function (model) {
      clearSkeletons(root);
      var more = root.querySelector('[data-rv-more]');

      // model === null → Abruf fehlgeschlagen (NICHT „0 Bewertungen"; das ist ein leeres reviews[]).
      if (!model) {
        if (status) status.textContent = L(cfg.i18n, 'error', 'Bewertungen konnten nicht geladen werden.');
        if (more) more.hidden = true;
        return;
      }

      if (!model.demo) applySummary(root, model);

      if (!model.reviews.length) {
        // Echte Leermenge: Empty-State zeigen (statt des irreführenden „wird geladen"-Textes).
        showEmpty(root, true);
        if (more) more.hidden = true;
        if (status) status.textContent = '';
        return;
      }

      showEmpty(root, false);
      renderHistogram(root, model.histogram);
      renderPhotos(root, model, cfg.i18n);
      renderAi(root, model.ai);
      setupList(root, model, cfg);
    }).catch(function (err) {
      clearSkeletons(root);
      if (status) status.textContent = L(cfg.i18n, 'error', 'Bewertungen konnten nicht geladen werden.');
      if (window && window.console) console.warn('[pdp-reviews]', err);
    });
  }

  function boot() {
    [].forEach.call(document.querySelectorAll('[data-reviews]'), init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  // Theme-Editor: Block neu geladen
  document.addEventListener('shopify:section:load', boot);
})();
